import { getIsFocusedInboxEnabled } from "owa-session-store";
import type { MailboxInfo } from "owa-client-types";
import { isUnifiedInboxMailboxInfo } from "owa-client-types/lib/UnifiedInboxMailboxInfo";

// Gets if Focused Inbox feature is enabled for the user
export function isFocusedInboxEnabled(mailboxInfo: MailboxInfo): boolean {
    // Enable in Unified Inbox if it's enabled in any mailbox in the unified inbox
    if (isUnifiedInboxMailboxInfo(mailboxInfo)) {
        return mailboxInfo.accountsMailboxInfos.some(mb => !!getIsFocusedInboxEnabled(mb));
    }
    
    return !!getIsFocusedInboxEnabled(mailboxInfo);
}
